import { privateApi } from 'api'
import { AxiosResponse } from 'axios'
import {
  ICreateDiscount,
  IDiscount,
  IDiscountProductsCount,
  IGetDiscountsQuery,
  IGetDiscountsResponse,
  IPreviewDiscountProducts,
  IUpdateDiscountStatus
} from 'models/discounts'
import {
  IGetHelperProductsQuery,
  IHelperProductsResponse
} from 'models/promoCodes'

export const discountsApi = {
  getDiscounts(
    query: IGetDiscountsQuery
  ): Promise<AxiosResponse<IGetDiscountsResponse>> {
    return privateApi.get<IGetDiscountsResponse>('admin/discount', {
      params: query
    })
  },
  // товары без действующей скидки (double-скидка невозможна)
  getProducts(
    query: IGetHelperProductsQuery
  ): Promise<AxiosResponse<IHelperProductsResponse>> {
    return privateApi.get<IHelperProductsResponse>(
      'admin/discount/helpers/products',
      {
        params: query
      }
    )
  },
  // сколько товаров получит скидку с такими настройками — для формы до сохранения
  previewProducts(
    data: IPreviewDiscountProducts
  ): Promise<AxiosResponse<IDiscountProductsCount>> {
    return privateApi.post<IDiscountProductsCount>(
      'admin/discount/preview',
      data
    )
  },
  getDiscount(id: string): Promise<AxiosResponse<IDiscount>> {
    return privateApi.get<IDiscount>(`admin/discount/${id}`)
  },
  createDiscount(data: ICreateDiscount): Promise<AxiosResponse<IDiscount>> {
    return privateApi.post<IDiscount>('admin/discount', data)
  },
  changeDiscountStatus(id: string, data: IUpdateDiscountStatus) {
    return privateApi.patch<IDiscount>(`admin/discount/${id}/status`, data)
  },
  updateDiscount(
    id: string,
    data: ICreateDiscount
  ): Promise<AxiosResponse<IDiscount>> {
    return privateApi.put<IDiscount>(`admin/discount/${id}`, data)
  }
}
